import { z } from "zod";

export const preferenceSchema = z.object({
  sortBy: z.string().nullish(),
  sortOrder: z.string().nullish(),
  searchValue: z.string().optional(),
  selectedFilters: z.record(z.array(z.record(z.unknown()))).optional(),
});

export type Preference = z.infer<typeof preferenceSchema>;

export const filterViewSchema = z.object({
  id: z.number(),
  is_default: z.boolean(),
  view_type: z.string(),
  view_name: z.string(),
  preference: preferenceSchema,
});

export const savedFilterViewsSchema = z.array(filterViewSchema);

export type SavedFilterView = z.infer<typeof filterViewSchema>;
export type SavedFilterViewsResponse = z.infer<typeof savedFilterViewsSchema>;

export const updateViewRequestPayloadSchema = z.object({
  id: z.number(),
  is_default: z.boolean().optional(),
  view_name: z.string(),
});

export type UpdateViewRequestPayload = z.infer<
  typeof updateViewRequestPayloadSchema
>;

export const createViewRequestPayloadSchema = z.object({
  view_name: z.string(),
  is_default: z.boolean(),
  preference: preferenceSchema,
});

export type CreateViewRequestPayload = z.infer<
  typeof createViewRequestPayloadSchema
>;
